
// DO NOT EDIT. This is a generated file.
// tslint:disable

export const BUILD_INFO = {
  "name": "admin-ui",
  "version": "1.27.1",
  "date": "2026-11-04T16:22:10.024Z",
  "branch": null,
  "rev": "fb99d5fd16",
  "tag": null,
  "commitsSinceLastTag": null,
  "authorDate": null,
  "buildNumber": null
};
